import { useEffect, useState } from "react";
import { useParams, useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { Branded, BrandLogo, PoweredBy, brandName } from "@/components/Brand";
import { errMsg } from "@/lib/api";

const pub = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

export default function ReferralLanding() {
  const { slug } = useParams();
  const [params] = useSearchParams();
  const code = params.get("ref") || "";
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  const [f, setF] = useState({ name: "", email: "", phone: "", note: "" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  useEffect(() => {
    sessionStorage.setItem("ip_biz", slug);
    if (!code) return setErr("That invite link is missing its code.");
    pub.get(`/public/referral/${code}`, { params: { b: slug } }).then((r) => setD(r.data)).catch((e) => setErr(errMsg(e)));
  }, [slug, code]);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr("");
    try { await pub.post(`/public/referral/${code}/lead`, { ...f, phone: f.phone || null, note: f.note || null }, { params: { b: slug } }); setDone(true); }
    catch (ex) { setErr(errMsg(ex)); } finally { setBusy(false); }
  };
  if (!d && err) return <div className="login fade" data-testid="referral-invalid"><h1>LINK NOT ACTIVE</h1><p data-testid="referral-error">{err}</p><Link to={`/b/${slug}`} className="btn" data-testid="referral-signin">Already a client? Sign in</Link></div>;
  if (!d) return <div className="center"><span className="spin" /></div>;
  const brand = d.brand;
  return (
    <Branded brand={brand}>
      <div className="login fade" style={{ maxWidth: 520 }} data-testid="referral-page">
        <div className="brand" style={{ marginBottom: 16 }}><BrandLogo brand={brand} size={34} testId="referral-brand-logo" /><div><b style={{ fontSize: 16 }} data-testid="referral-business-name">{brandName(brand).toUpperCase()}</b><small>INVITED BY {d.referrer.toUpperCase()}</small></div></div>
        {done ? (
          <div data-testid="referral-done">
            <h1>YOU'RE IN THE QUEUE</h1>
            <p>Thanks {f.name.split(" ")[0]} — {d.studioName} has your details and will reach out to set up your first session. {d.referrer} has been told you signed up. 🙌</p>
          </div>
        ) : (
          <>
            <h1 data-testid="referral-headline">{d.headline.toUpperCase()}</h1>
            <p data-testid="referral-blurb">{d.blurb}</p>
            <form onSubmit={submit} data-testid="referral-form">
              <label>Your name</label><input required minLength={2} value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="referral-name-input" />
              <label>Email</label><input required type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="referral-email-input" />
              <label>Phone (WhatsApp, optional)</label><input value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} data-testid="referral-phone-input" />
              <label>What are you after? (optional)</label><input value={f.note} onChange={(e) => setF({ ...f, note: e.target.value })} maxLength={300} placeholder="Strength, fat loss, getting back into it…" data-testid="referral-note-input" />
              <div style={{ marginTop: 20 }}><button className="btn" style={{ width: "100%" }} disabled={busy} data-testid="referral-submit-button">{busy ? "Sending…" : `I'm in — tell ${d.studioName}`}</button></div>
              {err && <div className="err" data-testid="referral-error">{err}</div>}
            </form>
          </>
        )}
        <PoweredBy />
      </div>
    </Branded>
  );
}
